(() => {
  const script = document.currentScript;
  const root = script && script.previousElementSibling;
  if (!root || !root.matches('[data-tan-business-finder]') || root.dataset.businessFinderReady) return;
  root.dataset.businessFinderReady = 'true';

  const choices = Array.from(root.querySelectorAll('[data-business-choice]'));
  const heading = root.querySelector('[data-business-result-heading]');
  const copy = root.querySelector('[data-business-result-copy]');
  const designList = root.querySelector('[data-business-design-list]');
  const spaceList = root.querySelector('[data-business-space-list]');
  const primary = root.querySelector('[data-business-primary]');
  const secondary = root.querySelector('[data-business-secondary]');
  const primaryFallbackLabel = primary?.textContent?.trim() || '';

  const activeChoice = (group) => root.querySelector(`[data-business-choice][data-choice-group="${group}"].is-active`);
  const payloadFor = (choice) => Array.from(root.querySelectorAll('[data-business-payload]')).find((payload) => payload.dataset.businessPayload === choice.dataset.choiceId);

  const update = () => {
    const starting = activeChoice('starting');
    const environment = activeChoice('environment');
    if (!starting || !environment || !heading || !copy) return;

    heading.textContent = `${starting.dataset.choiceTitle} · ${environment.dataset.choiceTitle}`;
    copy.textContent = [starting.dataset.choiceNote, environment.dataset.choiceNote].filter(Boolean).join(' ');

    const startingPayload = payloadFor(starting);
    const environmentPayload = payloadFor(environment);
    if (designList && startingPayload) {
      const content = startingPayload.content.querySelector('[data-choice-checklist]');
      designList.innerHTML = content ? content.innerHTML : '';
    }
    if (spaceList && environmentPayload) {
      const content = environmentPayload.content.querySelector('[data-choice-checklist]');
      spaceList.innerHTML = content ? content.innerHTML : '';
    }

    const environmentOverrides = environment.dataset.overrideCta === 'true' && environment.dataset.ctaLink;
    const primarySource = environmentOverrides ? environment : starting;
    if (primary) {
      primary.textContent = primarySource.dataset.ctaLabel || primaryFallbackLabel;
      primary.href = primarySource.dataset.ctaLink || '#';
      primary.hidden = !primarySource.dataset.ctaLink;
    }

    if (secondary) {
      secondary.textContent = environment.dataset.guideLabel || '';
      secondary.href = environment.dataset.guideLink || '#';
      secondary.hidden = !environment.dataset.guideLink || !environment.dataset.guideLabel;
    }
  };

  choices.forEach((choice) => {
    choice.addEventListener('click', () => {
      choices
        .filter((candidate) => candidate.dataset.choiceGroup === choice.dataset.choiceGroup)
        .forEach((candidate) => {
          const selected = candidate === choice;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      update();
    });
  });

  update();
})();
